var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    id: "svg831",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title827"
  }, "arrow-left2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title827"
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m 4.6288426,12.285536 9.9999984,10.000001 c 0.781,0.781 2.047,0.781 2.828,0 l 10,-10.000001 c 0.781,-0.781 0.781,-2.047 0,-2.8279995 -0.781,-0.781 -2.047,-0.781 -2.828,0 l -6.586,6.5859995 c -2.50134,2.50134 -1.661245,2.338755 -4,0 L 7.4568426,9.4575365 c -0.39,-0.39 -0.902,-0.586 -1.414,-0.586 -0.512,0 -1.024,0.195 -1.414,0.586 -0.781,0.7809995 -0.781,2.0469995 0,2.8279995 z",
    id: "path829-4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.5642572d.svg";
export { ForwardRef as ReactComponent };